import { getAncestorTypes as a } from "@project-rouge/rg-core";
import { Matrix4 as u } from "three";
import { getMatrix as x } from "../../geometry-utils/three/index9.js";
const d = ({
  obj: t,
  visible: r,
  allowed: n = y(r),
  parentMx: f = new u(),
  visibleObjs: e = Array(r.length).fill(0).map(() => []),
  filterBy: o
}) => {
  if (!n.includes(t.type))
    return [];
  if (o && !o(t))
    return [];
  const p = x(t).premultiply(f), c = r.indexOf(t.type);
  c !== -1 && e[c].push({
    obj: t,
    mx: p.toArray()
  });
  for (const m of t.children)
    d({
      obj: m,
      visible: r,
      allowed: n,
      parentMx: p,
      visibleObjs: e,
      filterBy: o
    });
  return e;
};
function y(t) {
  const r = t.flatMap((n) => a(n));
  return Array.from(
    new Set(r.concat(t))
  );
}
export {
  d as get2dPlanObjs
};
//# sourceMappingURL=index.js.map
